//平台管理者
import jmPlatforHome from '@/components/jm/platform/home.vue'

//设备信息
import macHome from '@/components/jm/platform/mac/home.vue'
import macList from '@/components/jm/platform/mac/list.vue'
//加盟商
import allianceHome from '@/components/jm/platform/alliance/home.vue'
import allianceAdd from '@/components/jm/platform/alliance/add.vue'
import allianceList from '@/components/jm/platform/alliance/list.vue'
import allianceUpdate from '@/components/jm/platform/alliance/update.vue'
//加盟商设备信息
import allianceMacHome from '@/components/jm/platform/alliance/mac/home.vue'
import allianceMacList from '@/components/jm/platform/alliance/mac/list.vue'
//加盟商设备货到信息
import allianceMacAisleHome from '@/components/jm/platform/alliance/mac/aisle/home.vue'
import allianceMacAisleList from '@/components/jm/platform/alliance/mac/aisle/list.vue'

//运营商
import operHome from '@/components/jm/platform/oper/home.vue'
import operAdd from '@/components/jm/platform/oper/add.vue'
import operList from '@/components/jm/platform/oper/list.vue'
import operUpdate from '@/components/jm/platform/oper/update.vue'
//运营商设备信息
import operMacHome from '@/components/jm/platform/oper/mac/home.vue'
import operMacList from '@/components/jm/platform/oper/mac/list.vue'
//运营商设备货到信息
import operMacAisleHome from '@/components/jm/platform/oper/mac/aisle/home.vue'
import operMacAisleList from '@/components/jm/platform/oper/mac/aisle/list.vue'

//广告管理者
import advHome from '@/components/jm/platform/advertising/home.vue'
import advAdd from '@/components/jm/platform/advertising/add.vue'
import advList from '@/components/jm/platform/advertising/list.vue'
import advUpdate from '@/components/jm/platform/advertising/update.vue'

//设备管理者
import facHome from '@/components/jm/platform/facility/home.vue'
import facList from '@/components/jm/platform/facility/list.vue'
import facAdd from '@/components/jm/platform/facility/add.vue'
import facUpdate from '@/components/jm/platform/facility/update.vue'
//外卖员
import waimaiHome from '@/components/jm/platform/waimai/home.vue'
import waimaiList from '@/components/jm/platform/waimai/list.vue'
import waimaiListMacAll from '@/components/jm/platform/waimai/listMacAll.vue'
import waimaiAdd from '@/components/jm/platform/waimai/add.vue'
import waimaiUpdate from '@/components/jm/platform/waimai/update.vue'
//平台人员

import platHome from '@/components/jm/platform/plat/home.vue'
import platList from '@/components/jm/platform/plat/list.vue'
import platAdd from '@/components/jm/platform/plat/add.vue'
import platUpdate from '@/components/jm/platform/plat/update.vue'

//工厂人员
import pcoductionHome from '@/components/jm/platform/pcoduction/home.vue'
import pcoductionList from '@/components/jm/platform/pcoduction/list.vue'
import pcoductionAdd from '@/components/jm/platform/pcoduction/add.vue'
import pcoductionUpdate from '@/components/jm/platform/pcoduction/update.vue'


//设备合同管理
import macOrderHome from '@/components/jm/platform/macOrder/home.vue'
import macOrderList from '@/components/jm/platform/macOrder/list.vue'
import macOrderAdd from '@/components/jm/platform/macOrder/add.vue'
import macOrderUpdate from '@/components/jm/platform/macOrder/update.vue'
//设备合同详情
import macOrderDetailsHome from '@/components/jm/platform/macOrder/details/home.vue'
import macOrderDetailsList from '@/components/jm/platform/macOrder/details/list.vue'
import macOrderDetailsAdd from '@/components/jm/platform/macOrder/details/add.vue'
import macOrderDetailsUpdate from '@/components/jm/platform/macOrder/details/update.vue'

//供应商合同管理
import macAisleOrderHome from '@/components/jm/platform/macAisleOrder/home.vue'
import macAisleOrderList from '@/components/jm/platform/macAisleOrder/list.vue'
import macAisleOrderAdd from '@/components/jm/platform/macAisleOrder/add.vue'
import macAisleOrderUpdate from '@/components/jm/platform/macAisleOrder/update.vue'

//平台为供应商分配货道时，查询设备信息
import allotMacAisleHome from '@/components/jm/platform/allotMacAisle/home.vue'
import allotMacList from '@/components/jm/platform/allotMacAisle/macList.vue'
import allotAisleList from '@/components/jm/platform/allotMacAisle/aisleList.vue'


//报表统计
import jmfinanceHome from '@/components/jm/platform/finance/home.vue'
import jmfinanceAllianceList from '@/components/jm/platform/finance/allianceList.vue'
import jmfinanceAllianceOrderDetails from '@/components/jm/platform/finance/allianceOrderDetails.vue'
import jmfinanceOperOrderDetails from '@/components/jm/platform/finance/operOrderDetails.vue'
import jmfinanceOperList from '@/components/jm/platform/finance/operList.vue'
import jmfinanceAdvList from '@/components/jm/platform/finance/advList.vue'
import jmfinanceAllianceEarnings from '@/components/jm/platform/finance/allianceEarnings.vue'
import jmfinanceAllianceEarningsMac from '@/components/jm/platform/finance/allianceEarningsMac.vue'
import jmfinanceOperEarnings from '@/components/jm/platform/finance/operEarnings.vue'
import jmfinanceOperEarningsMac from '@/components/jm/platform/finance/operEarningsMac.vue'
//用户管理
import clientHome from '@/components/jm/platform/client/home.vue'
import clientList from '@/components/jm/platform/client/list.vue'


//优惠券
import couponHome from '@/components/jm/platform/coupon/home.vue'
import couponList from '@/components/jm/platform/coupon/list.vue'
import couponListMac from '@/components/jm/platform/coupon/listMac.vue'
import couponAdd from '@/components/jm/platform/coupon/add.vue'
import couponUpdate from '@/components/jm/platform/coupon/update.vue'


//设备故障信息
import gzList from '../../../components/jm/platform/mac/gz/list.vue'
import gzHome from '../../../components/jm/platform/mac/gz/home.vue'
export default [{
	path: 'platform',
	name: 'platform',
	component: jmPlatforHome,
	children: [
		{ //优惠券
			path: 'gz',
			name: 'gz',
			component: gzHome,
			children: [{
				path: 'list',
				name: 'jm/platform/gz/list',
				component: gzList
			}]
		},
		{ //优惠券
			path: 'coupon',
			name: 'coupon',
			component: couponHome,
			children: [{
				path: 'list',
				name: 'jm/platform/coupon/list',
				component: couponList
			},{
				path: 'list/mac',
				name: 'jm/platform/coupon/list/mac',
				component: couponListMac
			}, {
				path: 'add',
				name: 'jm/platform/coupon/add',
				component: couponAdd
			}, {
				path: 'update',
				name: 'jm/platform/coupon/update',
				component: couponUpdate
			}]
		}, { //client
			path: 'client',
			name: 'client',
			component: clientHome,
			children: [{
				path: 'list',
				name: 'jm/platform/client/list',
				component: clientList
			}]
		}, { //设备信息
			path: 'mac',
			name: 'mac',
			component: macHome,
			children: [{
				path: 'list',
				name: 'jm/platform/mac/list',
				component: macList
			}]
		}, { //加盟商信息
		path: 'alliance',
		name: 'alliance',
		component: allianceHome,
		children: [{
			path: 'list',
			name: 'jm/platform/alliance/list',
			component: allianceList
		}, {
			path: 'add',
			name: 'jm/platform/alliance/add',
			component: allianceAdd
		}, {
			path: 'update',
			name: 'jm/platform/alliance/update',
			component: allianceUpdate
		}]
	}, { //加盟商设备信息
		path: 'allianceMac',
		name: 'allianceMac',
		component: allianceMacHome,
		children: [{
			path: 'list',
			name: 'jm/platform/alliance/mac/list',
			component: allianceMacList
		}]
	}, { //加盟商设备货到信息
		path: 'allianceMacAisle',
		name: 'allianceMacAisle',
		component: allianceMacAisleHome,
		children: [{
			path: 'list',
			name: 'jm/platform/alliance/mac/aisle/list',
			component: allianceMacAisleList
		}]
	}, { //运营商信息
		path: 'oper',
		name: 'oper',
		component: operHome,
		children: [{
			path: 'list',
			name: 'jm/platform/oper/list',
			component: operList
		}, {
			path: 'add',
			name: 'jm/platform/oper/add',
			component: operAdd
		}, {
			path: 'update',
			name: 'jm/platform/oper/update',
			component: operUpdate
		}]
	}, { //运营商设备信息
		path: 'opereMac',
		name: 'opereMac',
		component: operMacHome,
		children: [{
			path: 'list',
			name: 'jm/platform/oper/mac/list',
			component: operMacList
		}]
	}, { //运营商设备货道信息
		path: 'operMacAisle',
		name: 'operMacAisle',
		component: operMacAisleHome,
		children: [{
			path: 'list',
			name: 'jm/platform/oper/mac/aisle/list',
			component: operMacAisleList
		}]
	}, { //广告管理人员信息
		path: 'adv',
		name: 'adv',
		component: advHome,
		children: [{
			path: 'list',
			name: 'jm/platform/adv/list',
			component: advList
		}, {
			path: 'add',
			name: 'jm/platform/adv/add',
			component: advAdd
		}, {
			path: 'update',
			name: 'jm/platform/adv/update',
			component: advUpdate
		}]
	}, { //设备管理人员信息
		path: 'fac',
		name: 'fac',
		component: facHome,
		children: [{
			path: 'list',
			name: 'jm/platform/fac/list',
			component: facList
		}, {
			path: 'add',
			name: 'jm/platform/fac/add',
			component: facAdd
		}, {
			path: 'update',
			name: 'jm/platform/fac/update',
			component: facUpdate
		}]
	}, { //外卖人员
		path: 'waimai',
		name: 'waimai',
		component: waimaiHome,
		children: [{
			path: 'list',
			name: 'jm/platform/waimai/list',
			component: waimaiList
		},{
			path: 'list/mac/all',
			name: 'jm/platform/waimai/list/mac/all',
			component: waimaiListMacAll
		},  {
			path: 'add',
			name: 'jm/platform/waimai/add',
			component: waimaiAdd
		}, {
			path: 'update',
			name: 'jm/platform/waimai/update',
			component: waimaiUpdate
		}]
	}, { //平台人员信息
		path: 'plat',
		name: 'plat',
		component: platHome,
		children: [{
			path: 'list',
			name: 'jm/platform/plat/list',
			component: platList
		}, {
			path: 'add',
			name: 'jm/platform/plat/add',
			component: platAdd
		}, {
			path: 'update',
			name: 'jm/platform/plat/update',
			component: platUpdate
		}]
	}, { //工厂人员信息
		path: 'pcoduction',
		name: 'pcoduction',
		component: pcoductionHome,
		children: [{
			path: 'list',
			name: 'jm/platform/pcoduction/list',
			component: pcoductionList
		}, {
			path: 'add',
			name: 'jm/platform/pcoduction/add',
			component: pcoductionAdd
		}, {
			path: 'update',
			name: 'jm/platform/pcoduction/update',
			component: pcoductionUpdate
		}]
	}, { //设备订单信息
		path: 'macOrder',
		name: 'macOrder',
		component: macOrderHome,
		children: [{
			path: 'list',
			name: 'jm/platform/macOrder/list',
			component: macOrderList,
		}, {
			path: 'add',
			name: 'jm/platform/macOrder/add',
			component: macOrderAdd
		}, {
			path: 'update',
			name: 'jm/platform/macOrder/update',
			component: macOrderUpdate
		}]
	}, { //订单详细信息
		path: 'macOrderMac',
		name: 'macOrderMac',
		component: macOrderDetailsHome,
		children: [{
			path: 'list',
			name: 'jm/platform/macOrder/details/list',
			component: macOrderDetailsList
		}, {
			path: 'add',
			name: 'jm/platform/macOrder/details/add',
			component: macOrderDetailsAdd
		}, {
			path: 'update',
			name: 'jm/platform/macOrder/details/update',
			component: macOrderDetailsUpdate
		}]
	}, { //设备货道订单信息
		path: 'macAisleOrder',
		name: 'macAisleOrder',
		component: macAisleOrderHome,
		children: [{
			path: 'list',
			name: 'jm/platform/macAisleOrder/list',
			component: macAisleOrderList,
		}, {
			path: 'add',
			name: 'jm/platform/macAisleOrder/add',
			component: macAisleOrderAdd
		}, {
			path: 'update',
			name: 'jm/platform/macAisleOrder/update',
			component: macAisleOrderUpdate
		}]
	}, { //平台查询设备信息
		path: 'alliotMacAisle',
		name: 'alliotMacAisle',
		component: allotMacAisleHome,
		children: [{
			path: 'list',
			name: 'jm/platform/alliotMacAisle/macList',
			component: allotMacList,
		}, {
			path: 'list',
			name: 'jm/platform/alliotMacAisle/aisleList',
			component: allotAisleList,
		}]
	}, { //平台查询报表
		path: 'jmFinanceHome',
		name: 'jmFinanceHome',
		component: jmfinanceHome,
		children: [{
			path: 'allianceList',
			name: 'jm/platform/finance/allianceList',
			component: jmfinanceAllianceList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'allianceOrderDetails',
			name: 'jm/platform/finance/allianceOrderDetails',
			component: jmfinanceAllianceOrderDetails,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, 
		{
			path: 'operOrderDetails',
			name: 'jm/platform/finance/operOrderDetails',
			component: jmfinanceOperOrderDetails,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, 
		{
			path: 'operList',
			name: 'jm/platform/finance/operList',
			component: jmfinanceOperList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'advList',
			name: 'jm/platform/finance/advList',
			component: jmfinanceAdvList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'alliance/earnings',
			name: 'jm/platform/finance/alliance/earnings',
			component: jmfinanceAllianceEarnings,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'alliance/earnings/mac',
			name: 'jm/platform/finance/alliance/earnings/mac',
			component: jmfinanceAllianceEarningsMac,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'oper/earnings',
			name: 'jm/platform/finance/oper/earnings',
			component: jmfinanceOperEarnings,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'oper/earnings/mac',
			name: 'jm/platform/finance/oper/earnings/mac',
			component: jmfinanceOperEarningsMac,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}]
	}]
}]



// WEBPACK FOOTER //
// ./src/router/jm/platform/platform.js